var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifactiongray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#999999"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9992 7C15.3671 7 14.8563 7.50273 14.8563 8.125V8.7543C12.2671 9.15859 10.2849 11.3664 10.2849 14.0312V15.2055C10.2849 16.8016 9.73134 18.352 8.72063 19.5965L8.18849 20.2539C7.98134 20.507 7.94206 20.8551 8.08492 21.1469C8.22777 21.4387 8.52777 21.625 8.85634 21.625H23.1421C23.4706 21.625 23.7706 21.4387 23.9135 21.1469C24.0563 20.8551 24.0171 20.507 23.8099 20.2539L23.2778 19.6C22.2671 18.352 21.7135 16.8016 21.7135 15.2055V14.0312C21.7135 11.3664 19.7313 9.15859 17.1421 8.7543V8.125C17.1421 7.50273 16.6313 7 15.9992 7ZM15.9992 10.375H16.2849C18.3349 10.375 19.9992 12.0133 19.9992 14.0312V15.2055C19.9992 16.8895 20.4956 18.5312 21.4171 19.9375H10.5813C11.5028 18.5312 11.9992 16.8895 11.9992 15.2055V14.0312C11.9992 12.0133 13.6635 10.375 15.7135 10.375H15.9992ZM18.2849 22.75H15.9992H13.7135C13.7135 23.3477 13.9528 23.9207 14.3813 24.3426C14.8099 24.7645 15.3921 25 15.9992 25C16.6063 25 17.1885 24.7645 17.6171 24.3426C18.0456 23.9207 18.2849 23.3477 18.2849 22.75Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifactiongray);
export default __webpack_public_path__ + "static/media/notifactiongray.8a1361aead7ed92c94d18765c880ec24.svg";
export { ForwardRef as ReactComponent };